/**
 * Constants for builtin label IDs.
 * These should match the values defined in cloud-infra-py/src/cloud_infra_py/contracts/entities/labels/enums/builtin_label_id.py
 */

export const BuiltinLabelIds = {
  FALSE_POSITIVE: 'BUILTIN_FALSE-POSITIVE',
  TRUE_POSITIVE: 'BUILTIN_TRUE-POSITIVE',
  UNDER_REVIEW: 'BUILTIN_UNDER-REVIEW',
  BENIGN_TRUE_POSITIVE: 'BUILTIN_BENIGN-TRUE-POSITIVE',
  REMEDIATION_PERFORMED: 'BUILTIN_REMEDIATION-PERFORMED',
} as const;
